export const ADHESION = 'R$ 229,99';

export const CADASTRO_ONGOLD = 'https://cadastro.ongold.com.br/';